import { notify } from '@kyvg/vue3-notification'

export function useToast() {
  const successToast = (title = 'Success', text = 'Request was processed successfully') => {
    notify({
      group: 'foo',
      type: 'success',
      title,
      text,
      duration: 5000,
    })
  }

  const errorToast = (title = 'Error', text = 'Something went wrong') => {
    notify({
      group: 'foo',
      type: 'error',
      title,
      text,
      duration: 5000,
    })
  }

  const warningToast = (title = 'Warning', text = 'It seems something is not right') => {
    notify({
      group: 'foo',
      type: 'warn',
      title,
      text,
      duration: 5000,
    })
  }

  const infoToast = (title = 'Info', text = 'Here is some information') => {
    notify({
      group: 'foo',
      type: 'info',
      title,
      text,
      duration: 5000,
    })
  }

  return {
    successToast,
    errorToast,
    warningToast,
    infoToast,
  }
}
